import { HOST_NAME } from './url'

/**
 * Construct a URL for a static asset WITHOUT transformations.
 *
 * This is a client-side utility for referencing static assets (backgrounds,
 * default images) that don't need resizing or other transforms.
 *
 * WARNING: Do NOT pass transform options (w, h, dpr, etc.) — the image worker
 * requires a signed URL for transformed requests and will return 403.
 * For transformed static images on the server side, use
 * `getSignedStaticImageUrl` from `graphile/schema/utils/signedImageUrl`.
 *
 * @param path - Path to the asset (e.g., 'social-card-backgrounds/purple-yellow.png')
 * @returns Full URL to the static asset
 *
 * @example
 * getStaticImageUrl('social-card-backgrounds/purple-yellow.png')
 * // => "https://guild.host/i/static/social-card-backgrounds/purple-yellow.png"
 */
export function getStaticImageUrl(path: string): string {
  return `${HOST_NAME}/i/static/${path}`
}
